"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThreeDimensionalOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ThreeDimensionalOutlineSVG = function ThreeDimensionalOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28 8L17 1.6a1.8 1.8 0 00-1-.2 1.8 1.8 0 00-1 .2L4 8a1.9 1.9 0 00-1 1.7v11.7a2 2 0 00.9 1.7l11 7.2h.1l1 .2 1-.2h.1l11-7.2a2 2 0 00.9-1.7V9.7A1.9 1.9 0 0028 8zM15 28L5 21.4V10.8l10 5.8zm1-13.1L6 9.1l10-5.7 10 5.7zm11 6.5L17 28V16.6l10-5.8z"
  }));
};
exports.ThreeDimensionalOutlineSVG = ThreeDimensionalOutlineSVG;
ThreeDimensionalOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ThreeDimensionalOutlineSVG);
exports.default = _default;